import { Pipe, PipeTransform } from '@angular/core';
import { Params, Router } from '@angular/router';

@Pipe({
    name: 'withParams',
    standalone: true
})
export class WithParamsPipe implements PipeTransform {
    constructor(private router: Router) {}

    transform(url?: string, params?: Params | null): string | undefined {
        if (!url || !params) {
            return url;
        }
        return this.router.serializeUrl(this.router.createUrlTree([url], { queryParams: params }));
    }
}
